import { render } from "./ReportTotalsByCardType.vue?vue&type=template&id=23c4d49a&scoped=true"
import script from "./ReportTotalsByCardType.vue?vue&type=script&lang=js"
export * from "./ReportTotalsByCardType.vue?vue&type=script&lang=js"

import "./ReportTotalsByCardType.vue?vue&type=style&index=0&id=23c4d49a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c4d49a"]])

export default __exports__